module.exports = __webpack_public_path__ + "static/media/va.9ac64b09.svg";